import { useCallback } from "react";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialIntro } from "@/components/EditorialIntro";
import { Portfolio } from "@/components/Portfolio";
import { ServiceGrid } from "@/components/ServiceGrid";
import { Events } from "@/components/Events";
import { Process } from "@/components/Process";
import { About } from "@/components/About";
import { Testimonials } from "@/components/Testimonials";
import { FinalCTA } from "@/components/FinalCTA";
import { ContactForm } from "@/components/ContactForm";
import { Booking } from "@/components/Booking";
import { Footer } from "@/components/Footer";
import { PRODUCTION, CONTENT, ADVERTISING, DIGITAL } from "@/data/site";

export default function Home({ lenis }) {
  const onScrollTo = useCallback((href) => {
    if (href === "#top") {
      lenis ? lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.querySelector(href);
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -70 });
    else el.scrollIntoView({ behavior: "smooth" });
  }, [lenis]);

  return (
    <div className="bg-[#050505] text-[#fafafa]">
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#111", border: "1px solid rgba(255,255,255,0.1)", color: "#fafafa" } }} />
      <Navbar onScrollTo={onScrollTo} />
      <Hero onScrollTo={onScrollTo} />
      <EditorialIntro />
      <Portfolio />
      <ServiceGrid id="produktion" testId="production" label="Produktion" title="Wir" titleAccent="produzieren." intro="Von Commercials über Brand Films bis zur sendefähigen TV-Produktion — inklusive Schnitt, Color Grading und Postproduktion." items={PRODUCTION} />
      <ServiceGrid testId="content" label="Content" title="Content," titleAccent="der bewegt." intro="Social-First Formate, Reels und Produktfotografie, die als kreative Kampagne funktionieren — nicht als Einzelposting." items={CONTENT} id="content" />
      <ServiceGrid testId="advertising" label="Werbung" title="Create. Distribute." titleAccent="Grow." intro="Wir bringen die Bilder in die Distribution: Paid Social, Google, TV und eine Strategie, die auf Performance einzahlt." items={ADVERTISING} id="werbung" />
      <ServiceGrid testId="digital" label="Digital & Web" title="Ihre Marke." titleAccent="Digital." intro="Als Teil des Full-Service-Angebots: Websites, Landing Pages und digitale Markenauftritte, die zur Produktion passen." items={DIGITAL} id="digital" />
      <Events />
      <Process />
      <About />
      <Testimonials />
      <FinalCTA onScrollTo={onScrollTo} />
      <ContactForm />
      <Booking />
      <Footer onScrollTo={onScrollTo} />
    </div>
  );
}
